import { isNil } from 'lodash/fp';
import { useMemo } from 'react';
import useMarketList from '../../../utilities/useMarketList';

const useMarketOptions = (countryCode?: string) => {
    const { data, loading } = useMarketList();

    return useMemo(() => {
        if (loading) {
            return [];
        }

        return data
            .filter(market => (!isNil(countryCode) ? countryCode === market.countryCode : true))
            .map(({ name, code }) => ({ value: code, label: name }))
            .toSorted((a, b) => a.label.localeCompare(b.label));
    }, [countryCode, data, loading]);
};

export default useMarketOptions;
